import { ForwardedRef, PropsWithChildren } from "react";
import { IModalRefProps } from "../Drawer/types";
import { IButtonIcon } from "@repo/core/components/core/Button/ButtonIcon/types";
import { IconNames } from "@repo/core/components/core/Icon/types";

export type ModalTemplateProps = PropsWithChildren & {
  title?: string;
  text?: string;
  headerTitle?: string;
  description?: string;
  headerIcon?: IconNames;
  headerIconColor?: string;
  options?: IModalOption[];
  ref: ForwardedRef<IModalRefProps>;
};

export enum IModalTemplateType {
  "success" = "success",
  "danger" = "danger",
  "warning" = "warning",
  "outline" = "outline",
  "info" = "info"
}

export type IModalOption = {
  label: string;
  type?: IModalTemplateType;
  onPress?: () => void;
  isDisabled?: boolean;
  leftIcon?: IButtonIcon;
  rightIcon?: IButtonIcon;
};
